import { DeviceStatusInfo } from "@fairfleet/geotab/types";

/** Where a vehicle's unit last had a GPS fix, and when. */
export interface ChecklistPosition {
  latitude: number;
  longitude: number;
  dateTime: Date;
}

/**
 * The last GPS fix out of a unit's status info, or null when it has none.
 *
 * Geotab reports 0/0 for a unit that never had a fix; that point lies in the Atlantic and would
 * read as a real position.
 */
export function toChecklistPosition(
  statusInfo: DeviceStatusInfo | undefined,
): ChecklistPosition | null {
  const { latitude, longitude, dateTime } = statusInfo ?? {};
  if (latitude == null || longitude == null || !dateTime || (latitude === 0 && longitude === 0)) {
    return null;
  }
  const at = new Date(dateTime);
  if (Number.isNaN(at.getTime())) {
    return null;
  }
  return { latitude, longitude, dateTime: at };
}
